import LogoutRequestHandler from "./LogoutRequestHandler";
import {trans} from '../utils'
const Logout = () => {

    return (
        <a className="menu-link px-5 d-flex text-decoration-none" onClick={() => LogoutRequestHandler(true)} >
            <span className="symbol symbol-20px me-4">
            <i  className="bi bi-box-arrow-right fs-3"></i>
            </span>
             {trans('Logout')}  </a>
    );
};

export default Logout;
